<template>
  <transition
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
    enter-active-class="transition duration-100"
    leave-active-class="transition duration-100"
  >
    <TopBar
      v-if="links && ($flags.hasnt('enabledKiosk') || ($flags.has('enabledKiosk') && mgnlProps.showTopBarKiosk))"
      :links="links"
    />
  </transition>
</template>

<script lang="ts" setup>
import TopBar from './TopBar.vue';
import { TopBarBuilder, WrapperProps } from './TopBar.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);

const { $flags, $domain } = useNuxtApp();

const mgnlProps = TopBarBuilder.build(props);
const links = mgnlProps.links?.map(link => magnoliaGetters.getLinkAndName(link, $domain.cmsAssetDomainPath, link.switchable?.intLinkParam));
</script>
